import React from 'react';
import Profile from './Profile';

function ProfileTabs() {
    return <Profile />;
}

export default React.memo(ProfileTabs);
